"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static get values() {
    return {
      url: String,
      commentableGid: String,
      order: String,
      offset: Number,
      perPage: Number,
      alignment: Number
    };
  }
  static get targets() {
    return ["button", "spinner"];
  }
  connect() {
    this.loading = false;
  }
  /**
   * Load more comments when the button is clicked
   * @param {Event} event - The click event from the button
   * @returns {void}
   */
  loadMore(event) {
    return __async(this, null, function* () {
      event.preventDefault();
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.showLoadingState();
      try {
        const url = this.buildUrl();
        const response = yield this.makeRequest(url);
        if (response.ok) {
          const script = yield response.text();
          this.executeScript(script);
        } else {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
        this.hideLoadingState();
      }
    });
  }
  /**
   * Build the URL with query parameters for the AJAX request
   * @private
   * @returns {string} The URL with query parameters
   */
  buildUrl() {
    const locale = document.documentElement.getAttribute("lang") || "en";
    const params = new URLSearchParams({
      "commentable_gid": this.commentableGidValue,
      "order": this.orderValue,
      "offset": this.offsetValue,
      "locale": locale,
      "load_more": 1
    });
    if (this.hasAlignmentValue && typeof this.alignmentValue !== "undefined") {
      params.append("alignment", this.alignmentValue);
    }
    const separator = this.urlValue.includes("?") ? "&" : "?";
    return `${this.urlValue}${separator}${params.toString()}`;
  }
  /**
   * Make the HTTP request using fetch
   * @private
   * @param {string} url - The URL to request
   * @returns {Promise<Response>} The fetch response
   */
  makeRequest(url) {
    return __async(this, null, function* () {
      const csrfToken = this.getCSRFToken();
      return fetch(url, {
        method: "GET",
        headers: __spreadValues({
          "Accept": "text/javascript",
          "X-Requested-With": "XMLHttpRequest"
        }, csrfToken && { "X-CSRF-Token": csrfToken }),
        credentials: "same-origin"
      });
    });
  }
  /**
   * Get CSRF token from meta tag
   * @private
   * @returns {string|null} The CSRF token or null if not found
   */
  getCSRFToken() {
    const tokenElement = document.querySelector('meta[name="csrf-token"]');
    return tokenElement ? tokenElement.getAttribute("content") : null;
  }
  /**
   * Execute the JavaScript response from the server
   * @private
   * @param {string} script - The JavaScript code to execute
   * @returns {void}
   */
  executeScript(script) {
    const scriptElement = document.createElement("script");
    scriptElement.textContent = script;
    document.body.appendChild(scriptElement);
    document.body.removeChild(scriptElement);
  }
  /**
   * Show loading state on the button
   * @private
   * @returns {void}
   */
  showLoadingState() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true;
      this.buttonTarget.classList.add("loading");
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden");
    }
  }
  /**
   * Hide loading state on the button
   * @private
   * @returns {void}
   */
  hideLoadingState() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = false;
      this.buttonTarget.classList.remove("loading");
    }
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden");
    }
  }
  /**
   * Handle error response
   * @private
   * @param {Error} error - The error that occurred
   * @returns {void}
   */
  handleError(error) {
    console.error("Error loading more comments:", error);
    this.dispatch("error", {
      detail: {
        error: error.message,
        element: this.element
      }
    });
  }
  /**
   * Hide the load more button when no more comments are available
   * @public
   * @returns {void}
   */
  hideButton() {
    this.element.remove();
  }
}
